var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineDashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939090",
    d: "M6 6H10V9H6V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#939090",
    d: "M13 6H15V9H13V6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#939090",
    d: "M1 6H3V9H1V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDashed);
export default __webpack_public_path__ + "static/media/line_dashed.b57bd2fd546f1442f7eacf0b4bd2167f.svg";
export { ForwardRef as ReactComponent };